import React from 'react';
import NotificationsPage from '../common/NotificationsPage';

const AdminNotifications = () => <NotificationsPage title="Notifications" />;

export default AdminNotifications;
